import React, { useContext, useState } from 'react';

import { RestApiContext } from '../../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [pageIsReady, setPageIsReady] = useState(false);
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [state, setState] = useAggregatedState({
        user: null,
        roles: null,
        bundle: null,
        tables: null
    });

    const apiClient = useContext(RestApiContext);

    const getUserAsync = async (userId) => {
        try {
            const user = await apiClient.getUserAsync(userId);            
            setState({ user })
        } catch (e) {
            console.debug(e);
        }
    }

    const getRolesAsync = async () => {
        try {
            const roles = await apiClient.getRolesAsync(true, false);
            setState({ roles });
        } catch(e) {
            console.debug(e);
        }
    }

    const getTablesAsync = async (searchText, pageIndex, pageSize) => {
        try {
            const bundle = await apiClient.getManagedTablesAsync(searchText, false, pageIndex, pageSize);
            setState({ bundle, tables: bundle.items });
        } catch (e) {
            console.debug(e);
        }
    }      

    const addRoleToUserAsync = async ({ roleId , userId, tableId }) => {
        try {
            await apiClient.addRoleToUserAsync({ roleId , userId, tableId });
            const user = await apiClient.getUserAsync(userId);            
            setState({ user })
        } catch(e) {
            console.debug(e);
        }
    }

    const removeRoleForUserAsync = async (roleId, userId, tableId) => {
        try {
            await apiClient.revokeRoleForUserAsync(roleId , userId, [tableId]);
            const user = await apiClient.getUserAsync(userId);            
            setState({ user })
        } catch(e) {
            console.debug(e);
        }
    }    

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            getUserAsync,
            getRolesAsync,
            getTablesAsync,
            addRoleToUserAsync,
            removeRoleForUserAsync
        }}>
            {props.children}
        </Provider>
    );
}